import {FormsModule} from "@angular/forms";
import {NgSelectComponent} from "@ng-select/ng-select";
import {Component, EventEmitter, Input, Output} from '@angular/core';

export interface SortOption {
  id: number;
  name: string;
}

@Component({
    selector: 'nz-search-result',
    imports: [
        FormsModule,
        NgSelectComponent
    ],
    templateUrl: './search-result.component.html',
    styleUrl: './search-result.component.scss'
})
export class SearchResultComponent {
  @Input() totalResults: number = 0;
  @Input() selectedSortOption?: number;
  @Input() sortOptions: SortOption[] = [];
  @Output() onSortOptionChange: EventEmitter<number> = new EventEmitter<number>();
}
